export default "__VITE_ASSET__DqrU7Ydw__"